import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within ThemeProvider");
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem("theme");
    if (stored) return stored;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove("light", "dark", "glass");
    // Three dashboard effects: "light" (current), "dark", and "glass".
    // "glass" is a frosted-surface effect layered on the LIGHT colour scheme,
    // so it carries the `light` base class plus `glass`. light/dark unchanged.
    if (theme === "glass") root.classList.add("light", "glass");
    else root.classList.add(theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Existing toggle buttons now cycle through all three: light → dark → glass.
  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : prev === "dark" ? "glass" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
